import { setLanguage, setApplication } from "actions";

import { createStore } from "./store/createStore";
import { Provider } from "react-redux";
import { getRoutes, appsUrls } from "./router/getRoutes";

import { setAuthUser, fetchClientSettings, setCurrentClient } from "thunks";
import { BrowserRouter } from "react-router-dom";
import React from "react";

import { getCookie } from "utils";
import { initSentry } from "./sentry";
import { APP_ENV } from "Config";
import {
  getLocaleLanguage,
  getEmailingRedirectStorage,
  setEmailingRedirectStorage,
} from "EmailingAPI";

// App css
import "applicationStyles";

import TTPLoader from "./components/ui/TTPLoader";
import Layout from "./components/Layout";
import { fetchWebNotifications } from "./actions/thunks/notifications";

import { clearAllCookies } from "./services/auth";
import {
  setIsNlBlog,
  setIsUaNewsletter,
  setNewletterLanguage,
  setNewsletterFrequency,
  setProgrammedDate,
  setUaApprovalAction,
  setUaEbox,
  setUaIdApproval,
  setUaNewsletterId,
  setUaNewsletterNumber,
} from "./actions/actions/currentCampaign";
import moment from "moment";
import { decryptWithAES } from "./services/utils";
import { setIsUaVersion } from "./actions/actions/campaign";
import { setUAHeader } from "./actions/actions/auth";
import { createRoot } from "react-dom/client";
import AppRouteListener from "./router/AppRouteListener";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Configure Store
export const store = createStore();

// Install Talk Widget
//handleTalkWidget(store);

// Init Sentry
initSentry(store, {
  APP_ENV,
  APP_NAME: "sending",
  APP_RELEASE: "2",
  APP_SENTRY_DSN:
    "https://ee4f696d52e2c3ff7814046c96108ed0@o4509922458402816.ingest.de.sentry.io/4512202947690576",
});

const now = Math.floor(new Date().getTime() / 1000);
const userCookie = getCookie("ttp_auth_" + APP_ENV);
let loading = false;

const container = document.getElementById("app");
const root = createRoot(container);

const renderRoot = (content) => {
  root.render(
    <Provider store={store}>
      <BrowserRouter>{content}</BrowserRouter>
    </Provider>,
  );
};
// force community if id exists as a query param
const setCurrentCommunity = async () => {
  const { auth } = store.getState();

  const query = new URLSearchParams(window.location.search);
  const communityId = query.get("communityId");
  if (
    !communityId ||
    !auth?.user?.clients?.length ||
    communityId === auth?.currentClient.id
  ) {
    return;
  }
  const community = auth.user?.clients.find(
    (client) => client.id === communityId,
  );
  if (community) {
    await store.dispatch(setCurrentClient(community));
    await store.dispatch(fetchClientSettings());
  }
};

const App = () => (
  <>
    <AppRouteListener />
    <Layout>{getRoutes(store)}</Layout>
    <ToastContainer
      position="top-right"
      autoClose={4000}
      hideProgressBar={false}
      closeOnClick
      pauseOnHover
      draggable
    />
  </>
);
if (window.location.search) {
  const searchParams = new URLSearchParams(window.location.search);
  let hashParams = searchParams.get("params") || null;
  const { lng } = store.getState().params;

  let tab = {
    queryToken: "",
    userId: null,
    organization_id: null,
    portal: null,
    newsletterId: null,
    isUaNewsletter: false,
    newsletterNumber: null,
    newsletterFrequency: null,
    neweletterLanguage: null,
    scheduledDeliveryAt: null,
    idApproval: null,
    action: null,
    isNlBlog: false,
    ebox: false,
    language: lng,
  };
  if (hashParams) {
    clearAllCookies();

    hashParams = decryptWithAES(hashParams);
    const tabQueryParams = hashParams.split(",");
    tabQueryParams.forEach((item) => {
      const tmp = item.split("=");
      if (tmp.length > 0) {
        if (tmp[0] === "token") {
          tab.queryToken = tmp[1];
        } else if (tmp[0] === "userId") {
          tab.userId = tmp[1];
        } else if (tmp[0] === "without_header") {
          tab.uaWithoutHeader = true;
          store.dispatch(setUAHeader(true));
        } else if (tmp[0] === "fiduciary") {
          tab.organization_id = tmp[1];
          console.log("=== sendingOrganization ID from query params:", tmp[1]);
        } else if (tmp[0] === "newsletterId") {
          tab.newsletterId = tmp[1];
          store.dispatch(setUaNewsletterId(tmp[1]));
        } else if (tmp[0] === "isUaNewsletter") {
          tab.isUaNewsletter = tmp[1];
          store.dispatch(setIsUaNewsletter(tmp[1]));
        } else if (tmp[0] === "scheduledDeliveryAt") {
          tab.scheduledDeliveryAt = tmp[1];
          let scheduledDeliveryAt = moment(tmp[1]);
          store.dispatch(setProgrammedDate(scheduledDeliveryAt));
        } else if (tmp[0] === "idApproval") {
          tab.idApproval = tmp[1];
          store.dispatch(setUaIdApproval(tmp[1]));
        } else if (tmp[0] === "action") {
          tab.action = tmp[1];
          store.dispatch(setUaApprovalAction(tmp[1]));
        } else if (tmp[0] === "isNlBlog") {
          tab.isNlBlog = tmp[1];
          tmp[1] && store.dispatch(setIsNlBlog(tmp[1]));
        } else if (tmp[0] === "ebox") {
          tab.ebox = tmp[1];
          store.dispatch(setUaEbox(tmp[1]));
        } else if (tmp[0] === "lng") {
          tab.language = tmp[1];
          store.dispatch(setLanguage(tmp[1]));
        } else if (tmp[0] === "newsletterNumber") {
          tab.newsletterNumber = tmp[1];
          tmp[1] && store.dispatch(setUaNewsletterNumber(tmp[1]));
        } else if (tmp[0] === "newsletterFrequency") {
          tab.newsletterFrequency = tmp[1];
          tmp[1] && store.dispatch(setNewsletterFrequency(tmp[1]));
        } else if (tmp[0] === "neweletterLanguage") {
          tab.neweletterLanguage = tmp[1];
          tmp[1] && store.dispatch(setNewletterLanguage(tmp[1]));
        }
      }
    });
    const authInfos = {
      token: tab.queryToken,
      createdAt: Date.now(),
      expiresIn: 10000,
      id: tab.userId,
    };
    if (
      authInfos &&
      typeof authInfos === "object" &&
      now < parseInt(authInfos.createdAt) + parseInt(authInfos.expiresIn)
    ) {
      loading = true;
      store
        .dispatch(setAuthUser(authInfos))
        .then(async (res) => {
          let lng = getLocaleLanguage();
          let { language, clients } = res.value.data.data[0];
          store.dispatch(setLanguage(tab.language || lng || language || "fr"));
          store.dispatch(fetchWebNotifications());
          const community = clients.find(
            (client) => client.id == tab.organization_id,
          );
          if (community) {
            await store.dispatch(setCurrentClient(community));
            await store.dispatch(fetchClientSettings());
          }
          const uri = getEmailingRedirectStorage();
          if (uri) {
            window.location.replace(uri);
          }
          setEmailingRedirectStorage(null);
          store.dispatch(setIsUaVersion(true));
          await setCurrentCommunity();
        })
        .finally(() => {
          renderRoot(<App />);
        });
    }
  }
}

if (userCookie && userCookie.length > 0) {
  const authInfos = JSON.parse(userCookie);
  if (
    authInfos &&
    typeof authInfos === "object" &&
    now < parseInt(authInfos.createdAt) + parseInt(authInfos.expiresIn)
  ) {
    loading = true;
    store
      .dispatch(setAuthUser(authInfos))
      .then(async (res) => {
        let lng = getLocaleLanguage();
        let { language } = res.value.data.data[0];
        store.dispatch(setLanguage(lng || language || "fr"));
        store.dispatch(fetchWebNotifications());
        store.dispatch(fetchClientSettings());
        const uri = getEmailingRedirectStorage();
        if (uri) {
          window.location.replace(uri);
        }
        setEmailingRedirectStorage(null);
        await setCurrentCommunity();
      })
      .finally(() => {
        renderRoot(<App />);
      });
  }
}

renderRoot(loading ? <TTPLoader cssClass="fixed-loader" /> : <App />);
